import { Shape } from "types";

export default {};

export function drawShapes(
  shapes: Shape[],
  container: SVGSVGElement,
  scale = { x: 1, y: 1 }
) {
  shapes.forEach((shape) => {
    const { data } = shape;

    if (!data) return null;

    const element = document.createElementNS(
      "http://www.w3.org/2000/svg",
      data.type
    );
    element.setAttribute("stroke", data.color);
    element.setAttribute("stroke-width", `${data.width}`);
    element.setAttribute("fill", "none");
    element.setAttribute("transform", `scale(${scale.x}, ${scale.y})`);
    element.setAttribute(
      "points",
      data.value.points.map((point) => `${point.x},${point.y}`).join(" ")
    );

    // @ts-ignore
    container.appendChild(element);
  });
}

export function createShape(setting: any) {
  const element = document.createElementNS(
    "http://www.w3.org/2000/svg",
    setting.type
  );
  element.setAttribute("stroke", setting.color);
  element.setAttribute("stroke-width", `${setting.width}`);
  element.setAttribute("fill", "none");

  return element;
}
